var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 54,
    viewBox: "0 0 63 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.01489C23.7041 0 35.6121 11.908 35.6121 26.5972V26.5972C35.6121 41.2864 23.7041 53.1943 9.01489 53.1943H0V0Z",
    fill: "#8A38F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6123 0V0C50.2868 0 62.1829 11.9227 62.1829 26.5972V26.5972C62.1829 41.2717 50.2868 53.1943 35.6123 53.1943V53.1943V0Z",
    fill: "#8A38F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/half_circle.8629ce4a3842cd03aa1c4d6d126de7ae.svg";
export { ForwardRef as ReactComponent };